<template>
<v-card class="mb-2" flat>
    <v-form ref="orgForm" v-model="validOrg" lazy-validation>
        <alert-message :message="msg" :messageType="msgType" />
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <v-text-field v-model="organization.orgName" :rules="nameRules" label="Organization name *" style="font-size: 10" @input="generateSlug()" required>
                        <tool-tip title="Name of the Organization" slot="append" />
                    </v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-text-field v-model="organization.orgEmail" :rules="emailRules" label="E-mail *" required>
                        <template v-slot:append>
                            <tool-tip title="This email address will be used for sending all billing communication, all auto-generated reports etc." slot="append" />
                            <v-btn v-if="!verificationEmailSent" class="base-inverted" @click="verifyEmail()">Validate</v-btn>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" v-if="verificationEmailSent">
                    <v-text-field type="number" v-model.number="verificationCode" label="Verification Code*" required>
                        <template v-slot:append>
                            <v-btn class="base-inverted" v-if="!codeVerified" @click="verifyCode()">Verify</v-btn>
                            <v-icon color="green" v-else>mdi-check-bold</v-icon>
                        </template>
                    </v-text-field>
                    <label style="color:green">Please enter verification code received on {{organization.orgEmail}}</label>
                </v-col>
                <v-col cols="12">
                    <v-text-field v-model="organization.slug" onkeypress="return event.charCode != 32" @input="generateUrl()" :rules="slugRules" :hint="url" persistent-hint label="EasyProcess URL *" :disabled="!codeVerified">
                        <tool-tip title="This will be unique URL to access your Organization" slot="append" />
                    </v-text-field>
                </v-col>
                <v-col cols="12" class="text-center">
                    <label class="text-h5">Admin Details</label>
                </v-col>
                <v-col sm="6" cols="12">
                    <v-text-field v-model="admin.firstName" :rules="notEmpty" required label="First Name*" :disabled="!codeVerified"></v-text-field>
                </v-col>
                <v-col sm="6" cols="12">
                    <v-text-field v-model="admin.lastName" :rules="notEmpty" required label="Last Name*" :disabled="!codeVerified"></v-text-field>
                </v-col>
                <v-col sm="6" cols="12">
                    <v-text-field v-model="admin.email" :rules="emailRules" required label="E-mail*" :disabled="!codeVerified"></v-text-field>
                </v-col>
                <v-col sm="6" cols="12">
                    <v-text-field v-model="admin.phoneNo" :rules="numRules" required label="Mobile No.*" :disabled="!codeVerified"></v-text-field>
                </v-col>
                <v-col sm="6" cols="12">
                    <v-text-field type="password" v-model="admin.password" :rules="passwordRule" required label="Password*" :disabled="!codeVerified"></v-text-field>
                </v-col>
                <v-col sm="6" cols="12">
                    <v-text-field type="password" v-model="confirmPassword" :rules="passwordRule" required label="Confirm Password*" :disabled="!codeVerified"></v-text-field>
                    <label v-if="!passwordMatched" style="color:red">Password and confirm password should match</label>
                </v-col>
            </v-row>
        </v-card-text>
        <alert-message :message="msg" :messageType="msgType" />
        <v-card-actions>
            <div class="float-right text-right">
                <v-btn class="base-inverted" @click="validateOrg()">Register</v-btn>
            </div>
        </v-card-actions>
    </v-form>
</v-card>
</template>

<script>
import appConstants from '../utils/appConstants'
import ToolTip from './ToolTipComponent.vue'
export default {
  components: { ToolTip },
    data() {
        return {
            organization: this.defaultOrgObject(),
            admin: this.defaultAdminObject(),
            verificationEmailSent: false,
            codeVerified: false,
            verificationCode: undefined,
            msg: "",
            validOrg: true,
            url: "",
            confirmPassword: ""
        }
    },
    computed: {
        passwordMatched() {
            return this.admin.password == this.confirmPassword
        }
    },
    methods: {
        defaultOrgObject() {
            return {
                orgName: "",
                description: "",
                contactNumber: "",
                orgEmail: "",
                addresses: [],
                admins: [],
                _id: '',
            }
        },
        defaultAdminObject(){
            return {
                firstName: '',
                lastName: '',
                email: '',
                phoneNo: '',
                password:''
            }
        },
        async verifyEmail(){
            try {
                await this.postItem(appConstants.ORGANIZATIONS_API + "/verify-email", {emailId: this.organization.orgEmail});
                this.verificationEmailSent = true
            } catch (error) {
                console.error(error);
                this.handleError(error);
                this.msg = error?.response?.data?.details;
            }
        },
        async verifyCode(){
            try {
                await this.postItem(appConstants.ORGANIZATIONS_API + "/verify-code", {emailId: this.organization.orgEmail, code: this.verificationCode});
                this.codeVerified = true
            } catch (error) {
                this.handleError(error);
                //this.msg = error?.response?.data?.details;
            }
        },
        generateSlug() {
            this.organization.slug = this.organization.orgName.toLowerCase().replaceAll(" ", "-");
            this.generateUrl();
        },
        generateUrl() {
            this.url = location.protocol + "//" + location.host + "/" + this.organization.slug;
        },
        async validateOrg() {
            this.msg = ""
            if (this.$refs.orgForm.validate() && this.passwordMatched && this.codeVerified) {
                try {
                    this.organization['admins'] = [this.admin]
                    this.organization = await this.postItem(appConstants.ORGANIZATIONS_API + "/registration", this.organization);
                    this.$emit('success', this.organization)
                } catch (error) {
                    this.handleError(error);
                    this.msg = error.response.data.details;
                }
            }

        },
    },
}
</script>

<style lang="scss" scoped>

</style>
